import { create } from 'zustand';
import { clientProfileApi } from '../api/clientProfileApi';
import type { ClientProfile } from '../types/clientProfile';

interface ClientProfileState {
  data: ClientProfile | null;
  isLoading: boolean;
  isFetching: boolean;
  error: string | null;
  fetchProfile: () => Promise<void>;
  refetch: () => Promise<void>;
  setClientName: (name: string) => void;
}

const initialState = {
  data: null as ClientProfile | null,
  isLoading: false,
  isFetching: false,
  error: null as string | null,
};

export const useClientProfileStore = create<ClientProfileState>((set, get) => ({
  ...initialState,

  fetchProfile: async () => {
    if (get().isFetching) return;
    set({ isFetching: true, isLoading: get().data === null, error: null });
    try {
      const data = await clientProfileApi.getProfile();
      set({ data, isLoading: false, isFetching: false });
    } catch (err) {
      const isOffline = !navigator.onLine || (err as { code?: string })?.code === 'ERR_NETWORK';
      set({
        error: isOffline
          ? "Internet aloqasi yo'q. Qayta urinib ko'ring"
          : "Profil ma'lumotlarini yuklab bo'lmadi",
        isLoading: false,
        isFetching: false,
      });
    }
  },

  refetch: async () => {
    set({ data: null, error: null });
    await get().fetchProfile();
  },

  setClientName: (name) => {
    set((s) =>
      s.data
        ? { data: { ...s.data, client: { ...s.data.client, name } } }
        : s,
    );
  },
}));
